import { SET_ACCOUNT, CLEAR_ACCOUNT } from "./actionTypes";

export const setAccount = (account) => ({
  type: SET_ACCOUNT,
  payload: account,
});

export const clearAccount = () => ({
  type: CLEAR_ACCOUNT,
});